<div class="main-layout-bg">
    <div class="main-layout-panel">
        <header class="flex justify-between items-center px-6 py-4">
            <a routerLink="/" class="brand">
                <span class="brand-blocks" aria-hidden="true">
                    <span class="brand-block b1"></span>
                    <span class="brand-block b2"></span>
                    <span class="brand-block b3"></span>
                </span>
                <h1 class="brand-title">SNAKE MULTIPLAYER</h1>
            </a>
            @if (roomInfo(); as room) {
            <div class="chrome-center">
            <div class="chrome-frame">
            <div class="room-chrome">
                <div class="room-chrome-name">
                    @if (room.hasPassword) {
                    <span class="room-chrome-private" title="Private Room">PRIVATE</span>
                    }
                    <span class="room-chrome-title">{{ room.roomName }}</span>
                    <span class="room-chrome-count">{{ room.playerCount }}/{{ room.maxPlayers }}</span>
                </div>
                <div class="room-chrome-code">
                    <span class="room-chrome-code-text">{{ room.joinCode }}</span>
                    <button
                        class="room-chrome-copy"
                        (click)="copyRoomLink()"
                        aria-label="Copy room link"
                    >
                        COPY
                    </button>
                </div>
            </div>
            </div>
            <span class="leave-frame">
                <button class="header-leave" (click)="requestLeave()">⏻ LEAVE</button>
            </span>
            </div>
            }
            <div class="header-right">
                @if (username) {
                <span class="header-username">◆ {{ username }}</span>
                }
            </div>
        </header>
        <main>
            <router-outlet></router-outlet>
        </main>
        <footer class="py-4">
            <div class="px-4 text-center">
                @if (isRoomRoute()) {
                <p class="controls-hint">◄ ► ▲ ▼ MOVE · SPACE ATTACK · 1-3 TARGET · Q SWAP · E USE</p>
                } @else {
                <p>&copy; 2026 Snake Multiplayer. All rights reserved.</p>
                }
            </div>
            <span [class]="'status-pill ' + (connectionStatus().connected ? 'status-connected' : connectionStatus().connecting ? 'status-connecting' : 'status-disconnected')">
              <span class="status-dot" aria-hidden="true"></span>
              {{ connectionStatus().connected ? 'Connected' : connectionStatus().connecting ? 'Connecting...' : 'Disconnected' }}
            </span>
        </footer>
    </div>
</div>
